<template>
    <div>
        <template v-if="sessions_count > 1">
            <p>
                V vaš profil ste prijavljeni na lokacijah ({{ sessions_count }}). Želite da vas drugje odjavimo?
            </p>
            <v-btn class="noBtnMargin" depressed @click="doLogoutOther()" :loading="loading">Odjavi me na ostalih lokacijah</v-btn>
        </template>
        <template v-if="sessions_count < 2">
            <p>
                V vaš profil ste prijavljeni samo na trenutni lokaciji.
            </p>
        </template>
    </div>
</template>

<script>
    import {userService} from "../../../services";
    import utils from "../../../store/utils";

    export default {
        name: "ActiveLoginSessions",
        components: {},
        data: () => {
            return {
                loading: false,
            }
        },
        computed: {
            sessions_count: utils.vuexBuildSetGet(this, 'profile', 'sessions.count'),
        },
        methods: {
            doLogoutOther(){
                this.loading = true;
                userService.logoutOtherLocations().then((data) => {
                    this.$store.commit('profile/setSessionsData', {
                        count: 1
                    });
                }, (error) => {
                    // do nothing
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>
    .noBtnMargin {
        margin-left: 0px;
    }

</style>